import { ref, onMounted, onUnmounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dc667446"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content-wrap"
};
const _hoisted_2 = {
  key: 0,
  class: "filter-content"
};
const _hoisted_3 = {
  class: "filter-list-content"
};
const _hoisted_4 = {
  class: "input-select-content"
};
const _hoisted_5 = {
  class: "filter-list"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "产品名称：", -1));
const _hoisted_7 = {
  class: "filter-list",
  style: {
    "min-width": "fit-content"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "订单创建时间：", -1));
const _hoisted_9 = {
  class: "filter-list"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "支付渠道：", -1));
const _hoisted_11 = {
  class: "filter-list"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "设备ID：", -1));
const _hoisted_13 = {
  class: "filter-list"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "用户ID：", -1));
const _hoisted_15 = {
  class: "filter-list"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "DBT订单号：", -1));
const _hoisted_17 = {
  class: "filter-list"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "三方订单号：", -1));
const _hoisted_19 = {
  key: 0,
  class: "filter-list"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "advanced-btn"
}, "高级搜索", -1));
const _hoisted_21 = {
  class: "btn-content"
};
const _hoisted_22 = {
  key: 0,
  class: "filter-list-content small"
};
const _hoisted_23 = {
  class: "filter-list"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "内购ID", -1));
const _hoisted_25 = {
  class: "filter-list"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "客户端支付状态：", -1));
const _hoisted_27 = {
  class: "filter-list"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "服务端支付状态：", -1));
const _hoisted_29 = {
  class: "filter-list"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "赠送道具状态：", -1));
const _hoisted_31 = {
  class: "filter-list"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "应用版本：", -1));
const _hoisted_33 = {
  class: "filter-list"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "包名：", -1));
const _hoisted_35 = {
  class: "filter-list"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "原始渠道：", -1));
const _hoisted_37 = {
  class: "filter-list"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "advanced-btn"
}, "收起", -1));
const _hoisted_39 = {
  key: 1,
  class: "filter-content"
};
const _hoisted_40 = {
  class: "filter-list-content"
};
const _hoisted_41 = {
  class: "input-select-content"
};
const _hoisted_42 = {
  class: "filter-list"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "产品名称：", -1));
const _hoisted_44 = {
  class: "filter-list",
  style: {
    "min-width": "fit-content"
  }
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "订单创建时间：", -1));
const _hoisted_46 = {
  class: "filter-list",
  style: {
    "min-width": "fit-content"
  }
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "退款发起时间：", -1));
const _hoisted_48 = {
  class: "filter-list"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "设备ID：", -1));
const _hoisted_50 = {
  class: "filter-list"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "用户ID：", -1));
const _hoisted_52 = {
  class: "filter-list"
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "DBT订单号：", -1));
const _hoisted_54 = {
  class: "filter-list"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "三方订单号：", -1));
const _hoisted_56 = {
  key: 0,
  class: "filter-list"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "advanced-btn"
}, "高级搜索", -1));
const _hoisted_58 = {
  class: "btn-content"
};
const _hoisted_59 = {
  key: 0,
  class: "filter-list-content small"
};
const _hoisted_60 = {
  class: "filter-list"
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "内购ID", -1));
const _hoisted_62 = {
  class: "filter-list"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "支付渠道：", -1));
const _hoisted_64 = {
  class: "filter-list"
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "退款状态", -1));
const _hoisted_66 = {
  class: "filter-list"
};
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "advanced-btn"
}, "收起", -1));
import { queryGoodsOption } from '@/api/goodsSetting';
import { selectDimensionByDbtId } from '@/api/pay';
import { message } from 'ant-design-vue';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFilterBlock',
  props: {
    loading: {
      type: Boolean
    }
  },
  emits: ['filterSubmit', 'closeMore', 'changeType'],
  setup(__props, {
    emit
  }) {
    const dates = ref();
    const disabledDate = current => {
      if (!dates.value || dates.value.length === 0) {
        return false;
      }
      const tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 30;
      const tooEarly = dates.value[1] && dates.value[1].diff(current, 'days') > 30;
      return tooEarly || tooLate;
    };
    const hackValue = ref();
    const getNode = triggerNode => triggerNode.parentNode || document.body;
    const payStatusList = [{
      label: '全部',
      value: ''
    }, {
      label: '未支付',
      value: '0'
    }, {
      label: '支付成功',
      value: '1'
    }, {
      label: '支付失败',
      value: '2'
    }];
    const platOrderList = [{
      label: '全部',
      value: ''
    }, {
      label: '未支付',
      value: '0'
    }, {
      label: '支付成功',
      value: '1'
    }, {
      label: '支付失败',
      value: '2'
    }];
    const refundStatusList = [{
      label: '全部',
      value: ''
    },
    // { label: '退款开始', value: 0 },
    {
      label: '审核驳回',
      value: 12
    }, {
      label: '审批撤回',
      value: 11
    }, {
      label: '审批中',
      value: 10
    }, {
      label: '退款中',
      value: 30
    }, {
      label: '退款请求失败',
      value: 31
    }, {
      label: '退款失败',
      value: 32
    }, {
      label: '已退款',
      value: 40
    }, {
      label: '无法退款',
      value: 50
    }];
    //赠送道具状态 0-创建订单 1-赠送道具成功 2-支付失败
    const clientStatusList = [{
      label: '全部',
      value: ''
    }, {
      label: '创建订单',
      value: '0'
    }, {
      label: '赠送道具成功',
      value: '1'
    }, {
      label: '支付失败',
      value: '2'
    }];
    const orderTime = ref([dayjs().subtract(7, 'day'), dayjs().subtract(1, 'day')]);
    const refundTime = ref([dayjs().subtract(7, 'day'), dayjs().subtract(1, 'day')]);
    const appList = ref([]);
    const proRef = ref(null);
    const versionRef = ref(null);
    const prodList = ref([]);
    const chnlList = ref([]);
    const verList = ref([]);
    const payChnl = ref(null);
    const showMore = ref(true);
    const deviceId = ref('');
    const userId = ref('');
    const orderNo = ref('');
    const platOrderNo = ref('');
    const clientPayStatus = ref('');
    const platState = ref('');
    const clientStatus = ref('');
    const appVer = ref();
    const productName = ref();
    const chnl = ref('');
    const dbtId = ref();
    const pkg = ref('');
    const appName = ref('');
    const activeKey = ref('1');
    const refundStatus = ref(null);
    const format = 'YYYY-MM-DD';
    const filterSubmit = () => {
      if (!dbtId.value) return message.error('请先选择产品');
      if (activeKey.value === '1') {
        var _orderTime$value, _orderTime$value2;
        if (!((_orderTime$value = orderTime.value) !== null && _orderTime$value !== void 0 && _orderTime$value.length)) return message.error('请选择订单创建时间');
        let params = {
          deviceId: deviceId.value,
          orderNo: orderNo.value,
          platOrderNo: platOrderNo.value,
          clientPayStatus: clientPayStatus.value,
          platState: platState.value,
          clientStatus: clientStatus.value,
          appVer: appVer.value,
          dbtId: dbtId.value,
          pkg: pkg.value,
          chnl: chnl.value,
          payChnl: payChnl.value,
          prodId: productName.value,
          appName: appName.value,
          userId: userId.value
        };
        if ((_orderTime$value2 = orderTime.value) !== null && _orderTime$value2 !== void 0 && _orderTime$value2.length) {
          params = {
            ...params,
            beforeCreateDate: dayjs(orderTime.value[0]).format(format),
            afterCreateDate: dayjs(orderTime.value[1]).format(format) //订单创建时间
          };
        }
        emit('filterSubmit', params);
      } else {
        var _orderTime$value3, _refundTime$value;
        let params = {
          dbtId: dbtId.value,
          deviceId: deviceId.value,
          orderNo: orderNo.value,
          platOrderNo: platOrderNo.value,
          prodId: productName.value,
          payChnl: payChnl.value,
          refundStatus: refundStatus.value,
          userId: userId.value
        };
        if ((_orderTime$value3 = orderTime.value) !== null && _orderTime$value3 !== void 0 && _orderTime$value3.length) {
          params = {
            ...params,
            beforeCreateDate: dayjs(orderTime.value[0]).format(format),
            afterCreateDate: dayjs(orderTime.value[1]).format(format) //订单创建时间
          };
        }
        if ((_refundTime$value = refundTime.value) !== null && _refundTime$value !== void 0 && _refundTime$value.length) {
          params = {
            ...params,
            refundStartDate: dayjs(refundTime.value[0]).format(format),
            refundEndDate: dayjs(refundTime.value[1]).format(format) //退款发起时间
          };
        }
        if (!params.dbtId) return;
        emit('filterSubmit', params);
      }
    };
    const init = () => {
      var _proRef$value, _versionRef$value;
      dbtId.value = '';
      orderTime.value = [dayjs().subtract(7, 'day'), dayjs().subtract(1, 'day')];
      refundTime.value = [];
      deviceId.value = '';
      userId.value = '';
      orderNo.value = '';
      platOrderNo.value = '';
      clientPayStatus.value = '';
      platState.value = '';
      clientStatus.value = '';
      appVer.value = '';
      productName.value = '';
      chnl.value = '';
      pkg.value = '';
      appName.value = '';
      (_proRef$value = proRef.value) === null || _proRef$value === void 0 || _proRef$value.init();
      (_versionRef$value = versionRef.value) === null || _versionRef$value === void 0 || _versionRef$value.init();
      prodList.value = [];
      verList.value = [];
      refundStatus.value = null;
      payChnl.value = null;
      emit('filterSubmit', {
        beforeCreateDate: dayjs().subtract(7, 'day').format(format),
        afterCreateDate: dayjs().subtract(1, 'day').format(format),
        deviceId: '',
        orderNo: '',
        platOrderNo: '',
        clientPayStatus: '',
        platState: '',
        clientStatus: '',
        appVer: '',
        dbtId: '',
        pkg: '',
        chnl: '',
        prodId: '',
        appName: ''
      });
    };
    const closeMore = bool => {
      showMore.value = bool;
      emit('closeMore', bool);
    };
    const getAppData = async () => {
      try {
        const {
          code,
          data
        } = await queryGoodsOption();
        if (code === '0') {
          appList.value = data.map(item => {
            return {
              ...item,
              label: item.appName,
              value: item.dbtId,
              ...item.extData
            };
          });
          // 9/19 默认选择第一个应用
          // 3.29 取消选中第一个应用
          /*if(appList.value?.length) {
            dbtId.value = appList.value[0]?.value
            changeApp()
            filterSubmit()
          }*/
        }
      } catch (e) {}
    };
    const changeApp = () => {
      var _proRef$value2, _versionRef$value2;
      (_proRef$value2 = proRef.value) === null || _proRef$value2 === void 0 || _proRef$value2.init();
      (_versionRef$value2 = versionRef.value) === null || _versionRef$value2 === void 0 || _versionRef$value2.init();
      prodList.value = [];
      verList.value = [];
      getChannel([dbtId.value]);
      //获取应用中文名
      appList.value.forEach(item => {
        if (item.value === dbtId.value) {
          appName.value = item.dimensionName;
        }
      });
    };
    const getChannel = async arr => {
      try {
        const {
          code,
          data
        } = await selectDimensionByDbtId(arr);
        if (code === '0') {
          var _data$app_version, _data$prod_id, _data$pay_chnl;
          verList.value = data === null || data === void 0 || (_data$app_version = data.app_version) === null || _data$app_version === void 0 ? void 0 : _data$app_version.map(item => {
            return {
              ...item,
              checked: false,
              label: item.dimensionName,
              value: item.dimensionCode
            };
          });
          prodList.value = data === null || data === void 0 || (_data$prod_id = data.prod_id) === null || _data$prod_id === void 0 ? void 0 : _data$prod_id.map(item => {
            return {
              ...item,
              checked: false,
              label: item.dimensionName ? item.dimensionName + '(' + item.dimensionCode + ')' : item.dimensionCode,
              value: item.dimensionCode
            };
          });
          chnlList.value = data === null || data === void 0 || (_data$pay_chnl = data.pay_chnl) === null || _data$pay_chnl === void 0 ? void 0 : _data$pay_chnl.map(item => {
            return {
              ...item,
              checked: false,
              label: item.dimensionName ? item.dimensionName + '(' + item.dimensionCode + ')' : item.dimensionCode,
              value: item.dimensionCode
            };
          });
        }
      } catch (e) {}
    };
    const hack = () => {
      closeMore(showMore.value);
    };
    const filterOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }; // 下拉搜索label or value
    const changeType = () => {
      if (activeKey.value === '1') {
        orderTime.value = [dayjs().subtract(7, 'day'), dayjs().subtract(1, 'day')];
      } else {
        orderTime.value = [];
        refundTime.value = [];
      }
      emit('changeType', activeKey.value);
      setTimeout(() => {
        filterSubmit();
      }, 100);
    };
    const onChange = val => {
      orderTime.value = val;
    };
    const onCalendarChange = val => {
      dates.value = val;
    };
    const onOpenChange = open => {
      if (open) {
        dates.value = [];
        hackValue.value = [];
      } else {
        hackValue.value = undefined;
      }
    };
    onMounted(() => {
      getAppData();
      //监听表格resize
      window.addEventListener('resize', hack);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', hack);
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_input = _resolveComponent("a-input");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_tabs, {
        activeKey: activeKey.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => activeKey.value = $event),
        onChange: changeType
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "交易订单"
        }), _createVNode(_component_a_tab_pane, {
          key: "2",
          tab: "退款审批"
        })]),
        _: 1
      }, 8, ["activeKey"]), activeKey.value === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_a_select, {
        onChange: changeApp,
        value: dbtId.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => dbtId.value = $event),
        options: appList.value,
        placeholder: "输入产品或dbtid查询",
        "show-search": "",
        "allow-clear": "",
        "filter-option": filterOption,
        getPopupContainer: getNode
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_a_range_picker, {
        value: hackValue.value || orderTime.value,
        "disabled-date": disabledDate,
        onChange: onChange,
        onOpenChange: onOpenChange,
        onCalendarChange: onCalendarChange
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_a_select, {
        value: payChnl.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => payChnl.value = $event),
        options: chnlList.value,
        placeholder: "请选择",
        "show-search": "",
        "allow-clear": "",
        "filter-option": filterOption,
        getPopupContainer: getNode
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_a_input, {
        value: deviceId.value,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => deviceId.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_a_input, {
        value: userId.value,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => userId.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createVNode(_component_a_input, {
        value: orderNo.value,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => orderNo.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_a_input, {
        value: platOrderNo.value,
        "onUpdate:value": _cache[6] || (_cache[6] = $event => platOrderNo.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), !showMore.value ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[7] || (_cache[7] = () => closeMore(true))
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "arrow_blue",
          "class-name": "arrow-icon"
        })]),
        default: _withCtx(() => [_hoisted_20]),
        _: 1
      })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_a_button, {
        onClick: init,
        disabled: __props.loading
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit,
        disabled: __props.loading
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      }, 8, ["disabled"])])]), showMore.value ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createVNode(_component_a_input, {
        value: productName.value,
        "onUpdate:value": _cache[8] || (_cache[8] = $event => productName.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createVNode(_component_a_select, {
        "allow-clear": "",
        value: clientPayStatus.value,
        "onUpdate:value": _cache[9] || (_cache[9] = $event => clientPayStatus.value = $event),
        placeholder: "请选择",
        getPopupContainer: getNode,
        options: payStatusList
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createVNode(_component_a_select, {
        "allow-clear": "",
        value: platState.value,
        "onUpdate:value": _cache[10] || (_cache[10] = $event => platState.value = $event),
        placeholder: "请选择",
        getPopupContainer: getNode,
        options: platOrderList
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createVNode(_component_a_select, {
        "allow-clear": "",
        value: clientStatus.value,
        "onUpdate:value": _cache[11] || (_cache[11] = $event => clientStatus.value = $event),
        placeholder: "请选择",
        options: clientStatusList,
        getPopupContainer: getNode
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_31, [_hoisted_32, _createVNode(_component_a_select, {
        value: appVer.value,
        "onUpdate:value": _cache[12] || (_cache[12] = $event => appVer.value = $event),
        options: verList.value,
        placeholder: "请选择",
        "show-search": "",
        "allow-clear": "",
        "filter-option": filterOption,
        getPopupContainer: getNode
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createVNode(_component_a_input, {
        value: pkg.value,
        "onUpdate:value": _cache[13] || (_cache[13] = $event => pkg.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createVNode(_component_a_input, {
        value: chnl.value,
        "onUpdate:value": _cache[14] || (_cache[14] = $event => chnl.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_37, [_createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[15] || (_cache[15] = () => closeMore(false))
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "arrow_blue",
          "class-name": "arrow-icon rotate"
        })]),
        default: _withCtx(() => [_hoisted_38]),
        _: 1
      })])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), activeKey.value === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_hoisted_43, _createVNode(_component_a_select, {
        onChange: changeApp,
        value: dbtId.value,
        "onUpdate:value": _cache[16] || (_cache[16] = $event => dbtId.value = $event),
        options: appList.value,
        placeholder: "输入产品或dbtid查询",
        "show-search": "",
        "allow-clear": "",
        "filter-option": filterOption,
        getPopupContainer: getNode
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_44, [_hoisted_45, _createVNode(_component_a_range_picker, {
        value: hackValue.value || orderTime.value,
        "disabled-date": disabledDate,
        onChange: onChange,
        onOpenChange: onOpenChange,
        onCalendarChange: onCalendarChange
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_46, [_hoisted_47, _createVNode(_component_a_range_picker, {
        value: refundTime.value,
        "onUpdate:value": _cache[17] || (_cache[17] = $event => refundTime.value = $event)
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_48, [_hoisted_49, _createVNode(_component_a_input, {
        value: deviceId.value,
        "onUpdate:value": _cache[18] || (_cache[18] = $event => deviceId.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_50, [_hoisted_51, _createVNode(_component_a_input, {
        value: userId.value,
        "onUpdate:value": _cache[19] || (_cache[19] = $event => userId.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_52, [_hoisted_53, _createVNode(_component_a_input, {
        value: orderNo.value,
        "onUpdate:value": _cache[20] || (_cache[20] = $event => orderNo.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_54, [_hoisted_55, _createVNode(_component_a_input, {
        value: platOrderNo.value,
        "onUpdate:value": _cache[21] || (_cache[21] = $event => platOrderNo.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), !showMore.value ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[22] || (_cache[22] = () => closeMore(true))
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "arrow_blue",
          "class-name": "arrow-icon"
        })]),
        default: _withCtx(() => [_hoisted_57]),
        _: 1
      })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_58, [_createVNode(_component_a_button, {
        onClick: init,
        disabled: __props.loading
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_a_button, {
        type: "primary",
        onClick: filterSubmit,
        disabled: __props.loading
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      }, 8, ["disabled"])])]), showMore.value ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_hoisted_61, _createVNode(_component_a_input, {
        value: productName.value,
        "onUpdate:value": _cache[23] || (_cache[23] = $event => productName.value = $event),
        valueModifiers: {
          trim: true
        },
        placeholder: "请输入"
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_62, [_hoisted_63, _createVNode(_component_a_select, {
        value: payChnl.value,
        "onUpdate:value": _cache[24] || (_cache[24] = $event => payChnl.value = $event),
        options: chnlList.value,
        placeholder: "请选择",
        "show-search": "",
        "allow-clear": "",
        "filter-option": filterOption,
        getPopupContainer: getNode
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_64, [_hoisted_65, _createVNode(_component_a_select, {
        "allow-clear": "",
        value: refundStatus.value,
        "onUpdate:value": _cache[25] || (_cache[25] = $event => refundStatus.value = $event),
        placeholder: "请选择",
        getPopupContainer: getNode,
        options: refundStatusList
      }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_66, [_createVNode(_component_a_button, {
        type: "link",
        onClick: _cache[26] || (_cache[26] = () => closeMore(false))
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "arrow_blue",
          "class-name": "arrow-icon rotate"
        })]),
        default: _withCtx(() => [_hoisted_67]),
        _: 1
      })])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }
});